const firebaseConfig = {
  apiKey: "AIzaSyBhtUSpEtkcn_OiDdutKulx8aLYzQs0zeU",
  authDomain: "veg-green.firebaseapp.com",
  projectId: "veg-green",
  storageBucket: "veg-green.appspot.com",
  messagingSenderId: "1034480639015",
  appId: "1:1034480639015:web:6787a665e7559594bf0202"
};

  export default firebaseConfig;